import { render, staticRenderFns } from "./staffLayer.vue?vue&type=template&id=7f879df8&scoped=true"
import script from "./staffLayer.vue?vue&type=script&lang=js"
export * from "./staffLayer.vue?vue&type=script&lang=js"
import style0 from "./staffLayer.vue?vue&type=style&index=0&id=7f879df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f879df8",
  null
  
)

export default component.exports